import React, { useEffect, useMemo, useState } from 'react'
import { bindEvent } from '../modules/bindEvent'

import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import store, {
  RootState,
  AppDispatch,
  useAppDispatch,
  methods,
  notesSlice,
  configSlice,
  userSlice,
} from '../store'
import './Header.scss'
import { api } from '../modules/electron/api'
import httpApi from '../modules/http/api'
import { useTranslation } from 'react-i18next'
import { prompt, alert, snackbar } from '@saki-ui/core'
import { eventTarget } from '../store/config'
import NodeList, { noteMenuEvent } from '../components/NoteList'
import { SyncOff } from './Icon'
import { goTo, Query } from '../modules/methods'
import {
  SakiAvatar,
  SakiButton,
  SakiIcon,
  SakiMenu,
  SakiMenuItem,
  SakiRow,
} from './saki-ui-react/components'
import { isNoteSync, isShowEnbalSyncButton } from '../store/notes/methods'
import { byteConvert } from '@nyanyajs/utils'
import moment from 'moment'

const HeaderComponent = ({
  onSettings,
}: {
  onSettings: (type: string) => void
}) => {
  const { t, i18n } = useTranslation('index-header')
  const notes = useSelector((state: RootState) => state.notes)
  const config = useSelector((state: RootState) => state.config)
  const nsocketio = useSelector((state: RootState) => state.nsocketio)
  const appStatus = useSelector((state: RootState) => state.config.status)
  const user = useSelector((state: RootState) => state.user)

  const [openDropDownMenu, setOpenDropDownMenu] = useState(false)
  const [openNoteMoreDP, setOpenNoteMoreDP] = useState(false)
  const [openSettingDropDownMenu, setOpenSettingDropDownMenu] = useState(false)
  const [openUserDropDownMenu, setOpenUserDropDownMenu] = useState(false)
  const [showBackIcon, setShowBackIcon] = useState(false)

  const [historyLength, setHistoryLength] = useState(0)

  const dispatch = useDispatch<AppDispatch>()

  const location = useLocation()
  const history = useNavigate()

  // const [activeNote, setActiveNote] = useState(
  // 	notes.list?.filter((v) => {
  // 		return (
  // 			v.id ===
  // 			(location.pathname === '/'
  // 				? notes.noteId
  // 				: notes.quickReviewSelect.noteId)
  // 		)
  // 	})?.[0]
  // )

  const activeNote = notes.list?.filter((v) => {
    return (
      v.id ===
      (location.pathname !== '/quickreview'
        ? notes.noteId
        : notes.quickReviewSelect.noteId)
    )
  })?.[0]

  const fileSize = useMemo(() => {
    if (!activeNote) return 0
    return JSON.stringify(activeNote).length
  }, [activeNote?.id])

  useEffect(() => {
    console.log(
      'location',
      location.pathname === '/m' || location.pathname === '/m/p'
    )
    if (location.pathname === '/m' || location.pathname === '/m/p') {
      dispatch(configSlice.actions.setHeaderCenter(false))
    } else {
      dispatch(configSlice.actions.setHeaderCenter(true))
    }
    // if (location.pathname === '/') {
    // 	dispatch(configSlice.actions.setHeaderCenter(true))
    // }
    if (
      location.pathname === '/m/n' ||
      location.pathname === '/m/c' ||
      location.pathname === '/m/p'
    ) {
      setShowBackIcon(true)
    } else {
      setShowBackIcon(false)
    }
    setHistoryLength(historyLength + 1)
  }, [location])

  // useEffect(() => {
  // 	setActiveNote(
  // 		notes.list?.filter((v) => {
  // 			return (
  // 				v.id ===
  // 				(location.pathname !== '/quickreview'
  // 					? notes.noteId
  // 					: notes.quickReviewSelect.noteId)
  // 			)
  // 		})?.[0]
  // 	)
  // }, [notes.list, notes.noteId, notes.quickReviewSelect?.noteId])

  const [searchParams] = useSearchParams()
  let nid = searchParams.get('nid') || ''
  let cid = searchParams.get('cid') || ''
  let pid = searchParams.get('pid') || ''

  return (
    <div className={'header-component ' + config.deviceType}>
      <div className={'qv-h-left ' + (showBackIcon ? 'backIcon' : '')}>
        <saki-transition
          animation-duration={500}
          class-name="header-left"
          in={showBackIcon}
        >
          <div className="close">
            <saki-button
              ref={bindEvent({
                tap: (e) => {
                  // eventTarget.dispatchEvent(new Event('back'))

                  console.log('historyLength', historyLength)
                  console.log(nid, cid, pid)

                  let url = '/m'

                  if (nid) {
                    url = '/m'
                    if (cid) {
                      url = Query('/m/n', {
                        nid,
                      })
                      if (pid) {
                        url = Query('/m/c', {
                          nid,
                          cid,
                        })
                      }
                    }
                    history?.(url, {
                      replace: true,
                    })
                    return
                  }
                  history(-1)

                  // if (window.history.length === 1 || historyLength === 1) {
                  // 	history?.('/m', {
                  // 		replace: true,
                  // 	})
                  // 	return
                  // }
                  // history(-1)
                },
              })}
              type="CircleIconGrayHover"
            >
              <svg
                className="close-icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="1580"
              >
                <path
                  d="M395.21518 513.604544l323.135538-312.373427c19.052938-18.416442 19.052938-48.273447 0-66.660212-19.053961-18.416442-49.910737-18.416442-68.964698 0L291.75176 480.290811c-19.052938 18.416442-19.052938 48.273447 0 66.660212l357.633237 345.688183c9.525957 9.207709 22.01234 13.796214 34.497699 13.796214 12.485359 0 24.971741-4.588505 34.466999-13.82896 19.052938-18.416442 19.052938-48.242747 0-66.660212L395.21518 513.604544z"
                  p-id="1581"
                ></path>
              </svg>
            </saki-button>
          </div>
        </saki-transition>
        <saki-transition
          animation-duration={500}
          class-name="header-left"
          in={!showBackIcon}
        >
          <div className="logo text-elipsis">
            {showBackIcon ? (
              ''
            ) : (
              <div
                className="logo-info"
                title={t('appTitle', {
                  ns: 'common',
                })}
              >
                <img
                  src={config.origin + '/logo192.png'}
                  alt=""
                  crossOrigin="anonymous"
                />
                <span className="text-elipsis">
                  {t('appTitle', {
                    ns: 'common',
                  })}
                </span>
              </div>
            )}
          </div>
        </saki-transition>
      </div>
      {config.layout.showCenter ? (
        <div className="qv-h-center">
          {config.layout.centerTitle.title ? (
            <div className="qv-h-c-center-title">
              <div className="title text-elipsis">
                {config.layout.centerTitle.title}
              </div>
              <div className="subtitle text-elipsis">
                {config.layout.centerTitle.subtitle}
              </div>
            </div>
          ) : (
            <saki-dropdown
              visible={openDropDownMenu}
              floating-direction="Left"
              z-index="900"
              ref={bindEvent({
                close: (e) => {
                  setOpenDropDownMenu(false)
                },
              })}
            >
              <div
                onClick={() => {
                  setOpenDropDownMenu(!openDropDownMenu)
                }}
                className="qv-h-c-name"
              >
                <span className="name">{activeNote?.name || 'Add a note'}</span>
                {!isNoteSync(activeNote, 5) ? (
                  <SyncOff
                    style={{
                      marginLeft: '6px',
                    }}
                  />
                ) : notes.permissions[activeNote?.id || '']?.length >= 2 &&
                  notes.permissions[activeNote?.id || '']?.filter(
                    (v) => (v.authorId || '') === user.userInfo.uid
                  ).length >= 1 ? (
                  <SakiIcon
                    margin="0 0 0 4px"
                    color="#999"
                    type="Group"
                  ></SakiIcon>
                ) : (
                  ''
                )}
                <svg
                  className="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1561"
                >
                  <path
                    d="M512 761.6c-12.8 0-25.6-6.4-38.4-19.2l-448-448C0 275.2 0 236.8 25.6 217.6s57.6-19.2 76.8 0L512 627.2l409.6-409.6c19.2-19.2 57.6-19.2 76.8 0 19.2 19.2 19.2 57.6 0 76.8l-448 448C537.6 755.2 524.8 761.6 512 761.6z"
                    p-id="1562"
                  ></path>
                </svg>
              </div>
              <div
                style={{
                  width: '200px',
                }}
                slot="main"
              >
                <NodeList
                  onClose={() => {
                    setOpenDropDownMenu(false)
                  }}
                  onClick={(v) => {
                    console.log('id', v)

                    // history('//m/categories', {
                    // 	query: {
                    // 		id: v.id,
                    // 	},
                    // })
                    setOpenDropDownMenu(false)
                    if (!v?.id) return

                    switch (location.pathname) {
                      case '/':
                        dispatch(
                          notesSlice.actions.selectNote({
                            id: v.id,
                          })
                        )
                        break
                      case '/quickreview':
                        dispatch(
                          notesSlice.actions.setQuickReviewSelectData({
                            noteId: v.id,
                          })
                        )
                        break

                      default:
                        break
                    }
                  }}
                ></NodeList>
              </div>
            </saki-dropdown>
          )}
        </div>
      ) : (
        ''
      )}
      <div className="qv-h-right">
        {/* {String(nsocketio.status)}
				{String(!!user.token)} */}

        {nsocketio.status !== 'success' &&
        user.token &&
        config.deviceType !== 'Mobile' &&
        location.pathname !== '/quickreview' ? (
          <div className="qv-h-r-connecting">
            <saki-animation-loading
              type="rotateEaseInOut"
              width="20px"
              height="20px"
              border="3px"
              border-color="var(--default-color)"
            />
            <span
              style={{
                color: '#555',
              }}
            >
              {t('connecting', {
                ns: 'common',
              })}
            </span>
          </div>
        ) : (
          ''
        )}

        {notes.noteId ? (
          <saki-dropdown
            visible={openNoteMoreDP}
            floating-direction="Left"
            ref={bindEvent({
              close: (e) => {
                setOpenNoteMoreDP(false)
              },
            })}
          >
            <div className="qv-h-r-notemore">
              <saki-button
                ref={bindEvent({
                  tap: (e) => {
                    setOpenNoteMoreDP(true)
                  },
                })}
                type="CircleIconGrayHover"
                margin="0 0 0 4px"
                font-size="13px"
              >
                {appStatus.syncStatus ? (
                  <SakiIcon
                    color="#999"
                    width="20px"
                    height="20px"
                    type="Refresh3"
                    className="loading"
                  ></SakiIcon>
                ) : (
                  <SakiIcon
                    color="#666"
                    width="20px"
                    height="20px"
                    type="MenuSlim"
                  ></SakiIcon>
                )}
              </saki-button>
            </div>
            <div slot="main">
              <div className="qv-h-r-fileinfo">
                <div className="f-size">
                  <span>
                    {t('fileSize', {
                      ns: 'common',
                    })}
                    :
                  </span>
                  <span>{byteConvert(fileSize)}</span>
                </div>
                <div className="f-time">
                  <span>
                    {t('createTime', {
                      ns: 'common',
                    })}
                    :
                  </span>
                  <span>
                    {moment((activeNote?.createTime || 0) * 1000).format(
                      'YYYY.MM.DD'
                    )}
                  </span>
                </div>
                <div className="f-location">
                  <span>
                    {t('location', {
                      ns: 'common',
                    })}
                    :
                  </span>

                  <div className="f-right">
                    <SakiButton
                      onTap={() => {
                        goTo('https://cloud.aiiko.club/?p=/notes')
                      }}
                      padding="2px 0px 2px 4px"
                      type="Normal"
                      border="none"
                    >
                      <SakiRow alignItems="center" justifyContent="flex-end">
                        <span>
                          {t('goTo', {
                            ns: 'common',
                          })}
                        </span>
                        <SakiIcon
                          color="#999"
                          width="10px"
                          height="10px"
                          margin="1px 0 0 2px"
                          type="Right"
                        ></SakiIcon>
                      </SakiRow>
                    </SakiButton>
                  </div>
                </div>
              </div>
              <SakiMenu
                onSelectvalue={(e) => {
                  console.log(e.detail.value)

                  noteMenuEvent(activeNote, e.detail.value)
                  setOpenNoteMoreDP(false)
                }}
                width="190px"
                padding="0 0 6px"
              >
                <SakiMenuItem
                  padding="10px 18px"
                  value={'Sync'}
                  disabled={!isShowEnbalSyncButton(activeNote, 5)}
                >
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color={
                        !isShowEnbalSyncButton(activeNote, 5) ? '#999' : '#666'
                      }
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="Refresh3"
                    ></SakiIcon>
                    <span>
                      {activeNote?.isSync
                        ? t('turnOffSync', {
                            ns: 'common',
                          })
                        : t('turnOnSync', {
                            ns: 'common',
                          })}
                    </span>
                  </div>
                </SakiMenuItem>

                {activeNote?.authorId !== user.userInfo.uid ? (
                  <SakiMenuItem padding="10px 18px" value={'SaveToThisAccount'}>
                    <div className="qv-h-r-u-item">
                      <SakiIcon
                        color={'#666'}
                        width="16px"
                        height="16px"
                        margin="0 6px 0 0"
                        type="PaperAirplaneRight"
                      ></SakiIcon>
                      <span>
                        {t('saveToThisAccount', {
                          ns: 'common',
                        })}
                      </span>
                    </div>
                  </SakiMenuItem>
                ) : (
                  ''
                )}
                <SakiMenuItem padding="10px 18px" value={'Rename'}>
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color={'#666'}
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="PenWrite"
                    ></SakiIcon>
                    <span>
                      {t('renameThisNote', {
                        ns: 'indexPage',
                      })}
                    </span>
                  </div>
                </SakiMenuItem>
                <SakiMenuItem padding="10px 18px" value={'PullCloudData'}>
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color={'#666'}
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="DownloadCloud"
                    ></SakiIcon>
                    <span>
                      {t('pullCloudData', {
                        ns: 'indexPage',
                      })}
                    </span>
                  </div>
                </SakiMenuItem>
                <SakiMenuItem padding="10px 18px" value={'PushToCloud'}>
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color={'#666'}
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="UploadCloud"
                    ></SakiIcon>
                    <span>
                      {t('pushToCloud', {
                        ns: 'indexPage',
                      })}
                    </span>
                  </div>
                </SakiMenuItem>
                <SakiMenuItem padding="10px 18px" value={'Permissions'}>
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color={'#666'}
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="Permissions"
                    ></SakiIcon>
                    <span>
                      {t('permissions', {
                        ns: 'indexPage',
                      })}
                    </span>
                  </div>
                </SakiMenuItem>
                <SakiMenuItem padding="10px 18px" value={'Share'}>
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color={'#666'}
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="Share"
                    ></SakiIcon>
                    <span>
                      {t('share', {
                        ns: 'sakiuiPrompt',
                      })}
                    </span>
                  </div>
                </SakiMenuItem>

                {config.platform === 'Electron' ? (
                  <SakiMenuItem padding="10px 18px" value={'SaveAs'}>
                    <div className="qv-h-r-u-item">
                      <SakiIcon
                        color={'#666'}
                        width="16px"
                        height="16px"
                        margin="0 6px 0 0"
                        type="Download"
                      ></SakiIcon>
                      <span>
                        {t('saveAs', {
                          ns: 'common',
                        })}
                      </span>
                    </div>
                  </SakiMenuItem>
                ) : (
                  <SakiMenuItem padding="10px 18px" value={'Download'}>
                    <div className="qv-h-r-u-item">
                      <SakiIcon
                        color={'#666'}
                        width="16px"
                        height="16px"
                        margin="0 6px 0 0"
                        type="Download"
                      ></SakiIcon>
                      <span>
                        {t('download', {
                          ns: 'common',
                        })}
                      </span>
                    </div>
                  </SakiMenuItem>
                )}
                <SakiMenuItem padding="10px 18px" value={'HistoricalVersion'}>
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color={'#666'}
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="Time"
                    ></SakiIcon>
                    <span>
                      {t('pageTitle', {
                        ns: 'historicalVersionPage',
                      })}
                    </span>
                  </div>
                </SakiMenuItem>
                <SakiMenuItem padding="10px 18px" value={'Delete'}>
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color={'#666'}
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="Trash"
                    ></SakiIcon>
                    <span>
                      {t('delete', {
                        ns: 'common',
                      })}
                    </span>
                  </div>
                </SakiMenuItem>
              </SakiMenu>
            </div>
          </saki-dropdown>
        ) : (
          ''
        )}
        <div>
          <meow-apps-dropdown
            ref={bindEvent({
              openUrl: (e) => {
                switch (config.platform) {
                  case 'Electron':
                    const { shell } = window.require('electron')
                    shell.openExternal(e.detail)
                    break
                  case 'Web':
                    window.open(e.detail, '_blank')
                    break

                  default:
                    break
                }
              },
            })}
            disable-open-web-page
            weather={false}
            language={i18n.language}
          />
        </div>

        <saki-button
          ref={bindEvent({
            tap: () => {
              dispatch(
                configSlice.actions.setFindInAppModal({
                  visible: true,
                })
              )
            },
          })}
          type="CircleIconGrayHover"
          font-size="13px"
        >
          <SakiIcon
            color="#999"
            width="20px"
            height="20px"
            type="Magnifier"
          ></SakiIcon>
        </saki-button>
        <saki-dropdown
          visible={openSettingDropDownMenu}
          floating-direction="Left"
          ref={bindEvent({
            close: (e) => {
              setOpenSettingDropDownMenu(false)
            },
          })}
        >
          <div className="qv-h-r-setting">
            <saki-button
              ref={bindEvent({
                tap: (e) => {
                  setOpenSettingDropDownMenu(true)
                },
              })}
              type="CircleIconGrayHover"
              margin="0 0 0 4px"
              font-size="13px"
            >
              <SakiAvatar
                onTap={() => {
                  // onSettings?.()
                  // store.dispatch(userSlice.actions.logout({}))
                }}
                onMarkClick={() => {
                  console.log('onMarkClick')
                }}
                data-uid={user.userInfo.uid}
                width="34px"
                height="34px"
                border-radius="50%"
                default-icon={'UserLine'}
                mark={
                  !user.isLogin
                    ? false
                    : !(user.status === 1 && nsocketio.status === 'success')
                }
                markStatus={
                  user.status === 1 && nsocketio.status === 'success'
                    ? 'Online'
                    : 'Offline'
                }
                nickname={user.userInfo.nickname}
                src={user.userInfo.avatar}
              />
            </saki-button>
          </div>
          <div slot="main">
            <saki-menu
              ref={bindEvent({
                selectvalue: async (e) => {
                  console.log(e.detail.value)
                  switch (e.detail.value) {
                    case 'Setting':
                      switch (config.deviceType) {
                        case 'Mobile':
                          onSettings?.('')
                          break

                        default:
                          onSettings?.('General')
                          break
                      }
                      break
                    case 'NoteInvitationCode':
                      dispatch(
                        configSlice.actions.setCloudNoteModal({
                          visible: true,
                        })
                      )
                      break
                    case 'OpenDevTools':
                      api.openDevTools()
                      break
                    case 'Logout':
                      dispatch(methods.user.logout())
                      break

                    case 'Quit':
                      alert({
                        title: t('quitModalTitle', {
                          ns: 'common',
                        }),
                        content: t('quitModalContent', {
                          ns: 'common',
                        }),
                        cancelText: t('cancel', {
                          ns: 'common',
                        }),
                        confirmText: t('quit', {
                          ns: 'common',
                        }),
                        onCancel() {},
                        onConfirm() {
                          window
                            .require('electron')
                            ?.ipcRenderer?.send?.('quit')
                        },
                      }).open()
                      break
                    case 'login':
                      store.dispatch(
                        configSlice.actions.setStatus({
                          type: 'loginModalStatus',
                          v: true,
                        })
                      )
                      break

                    default:
                      break
                  }
                  setOpenSettingDropDownMenu(false)
                },
              })}
            >
              {!user.isLogin ? (
                <saki-menu-item padding="10px 18px" value={'login'}>
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color="#666"
                      width="16px"
                      height="16px"
                      margin="0 6px 0 0"
                      type="UserLine"
                    ></SakiIcon>
                    <span>
                      {t('login', {
                        ns: 'sakiuiPrompt',
                      })}
                    </span>
                  </div>
                </saki-menu-item>
              ) : (
                ''
              )}
              <saki-menu-item padding="10px 18px" value={'Setting'}>
                <div className="qv-h-r-u-item">
                  <SakiIcon
                    color="#666"
                    width="16px"
                    height="16px"
                    margin="0 6px 0 0"
                    type="Settings"
                  ></SakiIcon>
                  <span>
                    {t('title', {
                      ns: 'settings',
                    })}
                  </span>
                </div>
              </saki-menu-item>

              {user.isLogin ? (
                <saki-menu-item
                  padding="10px 18px"
                  value={'NoteInvitationCode'}
                >
                  <div className="qv-h-r-u-item">
                    <SakiIcon
                      color="#666"
                      width="16px"
                      height="14px"
                      margin="0 6px 0 0"
                      type="Send"
                    ></SakiIcon>
                    <span>
                      {t('noteInvitationCode', {
                        ns: 'indexPage',
                      })}
                    </span>
                  </div>
                </saki-menu-item>
              ) : (
                ''
              )}

              {/* 
							{user.isLogin && (
								<saki-menu-item
									width='150px'
									padding='10px 18px'
									value={'CloudBackup'}
								>
									<div className='qv-h-r-u-item'>
										<SakiIcon
											color='#666'
											width='17px'
											height='17px'
											margin='0 6px 0 0'
											type='Time'
										></SakiIcon>
										<span>
											{t('cloudBackup', {
												ns: 'common',
											})}
										</span>
									</div>
								</saki-menu-item>
							)} */}
              {config.platform === 'Electron' ? (
                <>
                  <saki-menu-item padding="10px 18px" value={'OpenDevTools'}>
                    <div className="qv-h-r-u-item">
                      <svg
                        className="icon"
                        viewBox="0 0 1025 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="7990"
                      >
                        <path
                          d="M293.0688 755.2c-12.0832 0-24.2688-4.2496-33.9968-12.9024L0 512l273.4592-243.0976C294.5536 250.2144 326.912 252.0064 345.7024 273.152c18.7904 21.1456 16.896 53.504-4.2496 72.2944L154.112 512l172.9536 153.7024c21.1456 18.7904 23.04 51.1488 4.2496 72.2944C321.2288 749.4144 307.1488 755.2 293.0688 755.2zM751.0528 755.0976 1024.512 512l-259.072-230.2976c-21.1456-18.7904-53.504-16.896-72.2432 4.2496-18.7904 21.1456-16.896 53.504 4.2496 72.2944L870.4 512l-187.3408 166.5024c-21.1456 18.7904-23.04 51.1488-4.2496 72.2944C688.896 762.2144 702.976 768 717.056 768 729.1392 768 741.3248 763.7504 751.0528 755.0976zM511.5392 827.648l102.4-614.4c4.6592-27.904-14.1824-54.272-42.0864-58.9312-28.0064-4.7104-54.3232 14.1824-58.88 42.0864l-102.4 614.4c-4.6592 27.904 14.1824 54.272 42.0864 58.9312C455.5264 870.1952 458.2912 870.4 461.1072 870.4 485.6832 870.4 507.392 852.6336 511.5392 827.648z"
                          p-id="7991"
                        ></path>
                      </svg>
                      <span>
                        {t('openDevtools', {
                          ns: 'common',
                        })}
                      </span>
                    </div>
                  </saki-menu-item>
                  <saki-menu-item padding="10px 18px" value={'Quit'}>
                    <div className="qv-h-r-u-item">
                      <svg
                        className="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8392"
                      >
                        <path
                          d="M562.972444 554.666667c0 28.103111-22.869333 50.972444-51.029333 50.972444-28.216889 0-50.972444-22.755556-50.972444-50.972444L460.970667 112.526222c0-28.103111 22.869333-50.972444 50.972444-50.972444s51.029333 22.869333 51.029333 50.972444L562.972444 554.666667 562.972444 554.666667zM84.593778 535.438222c0-152.576 80.554667-286.663111 201.102222-361.813333 23.608889-15.018667 55.125333-7.850667 69.973333 16.042667C370.631111 213.617778 363.463111 244.963556 339.626667 259.868444 247.694222 317.610667 186.652444 419.043556 186.652444 535.324444c0.398222 179.598222 145.635556 324.892444 325.290667 325.233778 179.598222-0.455111 324.778667-145.692444 325.12-325.233778 0-119.011556-64.227556-222.663111-159.800889-279.552-24.291556-14.392889-32.256-45.738667-17.92-69.973333 14.449778-24.177778 45.795556-32.142222 70.030222-17.806222 125.326222 74.012444 209.976889 210.830222 209.976889 367.274667 0 235.918222-191.260444 427.235556-427.292444 427.235556C275.911111 962.787556 84.593778 771.584 84.593778 535.438222"
                          p-id="8393"
                        ></path>
                      </svg>
                      <span>
                        {t('quit', {
                          ns: 'common',
                        })}
                      </span>
                    </div>
                  </saki-menu-item>
                </>
              ) : (
                ''
              )}

              {/* {user.isLogin && (
								<saki-menu-item
									width='150px'
									padding='10px 18px'
									value={'Logout'}
								>
									<div className='qv-h-r-u-item'>
										<svg
											className='icon'
											viewBox='0 0 1024 1024'
											version='1.1'
											xmlns='http://www.w3.org/2000/svg'
											p-id='3480'
										>
											<path
												d='M835.669333 554.666667h-473.173333A42.453333 42.453333 0 0 1 320 512a42.666667 42.666667 0 0 1 42.474667-42.666667h473.173333l-161.813333-161.834666a42.666667 42.666667 0 0 1 60.330666-60.330667l234.666667 234.666667a42.666667 42.666667 0 0 1 0 60.330666l-234.666667 234.666667a42.666667 42.666667 0 0 1-60.330666-60.330667L835.669333 554.666667zM554.666667 42.666667a42.666667 42.666667 0 1 1 0 85.333333H149.525333C137.578667 128 128 137.578667 128 149.482667v725.034666C128 886.4 137.6 896 149.525333 896H554.666667a42.666667 42.666667 0 1 1 0 85.333333H149.525333A106.816 106.816 0 0 1 42.666667 874.517333V149.482667A106.773333 106.773333 0 0 1 149.525333 42.666667H554.666667z'
												fill=''
												p-id='3481'
											></path>
										</svg>
										<span>
											{t('logout', {
												ns: 'common',
											})}
										</span>
									</div>
								</saki-menu-item>
							)} */}
            </saki-menu>
          </div>
        </saki-dropdown>

        {/* <saki-dropdown
					// style={{
					// 	display: user.isLogin ? 'block' : 'none',
					// }}
					visible={openUserDropDownMenu}
					floating-direction='Left'
					ref={bindEvent({
						close: (e) => {
							setOpenUserDropDownMenu(false)
						},
					})}
				>
					<div
						onClick={() => {
							onSettings?.('Account')
							// setOpenUserDropDownMenu(!openUserDropDownMenu)
						}}
						className='qv-h-r-user'
					>
						<saki-avatar
							ref={bindEvent({
								tap: () => {
									// onSettings?.()
									// store.dispatch(userSlice.actions.logout({}))
								},
							})}
							className='qv-h-r-u-avatar'
							width='34px'
							height='34px'
							border-radius='50%'
							default-icon={'UserLine'}
							nickname={user.userInfo.nickname}
							src={user.userInfo.avatar}
							alt=''
						/>
					</div>
					<div slot='main'>
						<saki-menu
							ref={bindEvent({
								selectvalue: async (e) => {
									console.log(e.detail.value)
									switch (e.detail.value) {
										case 'Setting':
											onSettings?.('')
											break

										default:
											break
									}
									setOpenUserDropDownMenu(false)
								},
							})}
						>
							<saki-menu-item
								width='150px'
								padding='10px 18px'
								value={'Logout'}
							>
								<div className='qv-h-r-u-item'>
									<svg
										className='icon'
										viewBox='0 0 1024 1024'
										version='1.1'
										xmlns='http://www.w3.org/2000/svg'
										p-id='3480'
									>
										<path
											d='M835.669333 554.666667h-473.173333A42.453333 42.453333 0 0 1 320 512a42.666667 42.666667 0 0 1 42.474667-42.666667h473.173333l-161.813333-161.834666a42.666667 42.666667 0 0 1 60.330666-60.330667l234.666667 234.666667a42.666667 42.666667 0 0 1 0 60.330666l-234.666667 234.666667a42.666667 42.666667 0 0 1-60.330666-60.330667L835.669333 554.666667zM554.666667 42.666667a42.666667 42.666667 0 1 1 0 85.333333H149.525333C137.578667 128 128 137.578667 128 149.482667v725.034666C128 886.4 137.6 896 149.525333 896H554.666667a42.666667 42.666667 0 1 1 0 85.333333H149.525333A106.816 106.816 0 0 1 42.666667 874.517333V149.482667A106.773333 106.773333 0 0 1 149.525333 42.666667H554.666667z'
											fill=''
											p-id='3481'
										></path>
									</svg>
									<span>
										{t('logout', {
											ns: 'common',
										})}
									</span>
								</div>
							</saki-menu-item>
						</saki-menu>
					</div>
				</saki-dropdown> */}
      </div>
    </div>
  )
}

export default HeaderComponent
